<template>
  <div class="user-list">
    <UserItem
      v-for="user in users"
      :key="user.href"
      :title="user.title"
      :href="user.href"
      :avatar="user.avatar"
      avatar-size="medium-small"
    />
  </div>
</template>

<script>
  import UserItem from "src/components/users/UserItem/UserItem.vue";

  export default {
    name: 'UserList',
    components: { UserItem },
    props: {
      users: {
        type: Array,
        required: true,
      }
    }
  }
</script>